import React from 'react';
import styled from 'styled-components';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

const StyledIcon = styled(InfoCircleOutlined)`
  color: #123fbf !important;
  margin-left: 5px;
  height: 100%;
`;
const Title = styled.span`
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
`;

const Container = styled.div`
  color: #123fbf;
`;
export default function AINotifier({ isAIgenerated = false }) {
  if (!isAIgenerated) return null;
  return (
    <Container>
      <Title>AI Generated VMRS</Title>
      <Tooltip title="VMRS codes help generate accurate fleet reports. If a code isn't provided for older work orders, we'll use AI to suggest one based on the work order details.">
        <StyledIcon />
      </Tooltip>
    </Container>
  );
}
